import React, { useState, useEffect } from "react";
import { safeParseJSONString } from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// Component
import 'survey-react/survey.css';
import * as Survey from 'survey-react';

// Component styles
import classes from "./SurveyJsPlayerWidget.module.scss";

const EMPTY = undefined;

export function SurveyJsPlayerWidget(props) {
  const { ui, data, config, writeBack } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);

  let model = config ? config.SurveyJson : null;
  let content = data && data.content ? safeParseJSONString(data.content) : null;
  let disabled = ui.readonly || (data && data.readonly);
  let survey = createSurvey(model, content, disabled);

  useEffect(() => {
    console.log("SurveyJsPlayerWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  useEffect(() => {
    console.log("SurveyJsPlayerWidget model changed");
    setLocalContent(EMPTY);
  }, [config]);

  function createSurvey(m, c, d) {
    console.log("Survey create");
    let survey = new Survey.Model(m);
    survey.data = c;
    survey.mode = d ? "display" : "edit"
    return survey;
  };

  const onValueChanged = (args) => {
    console.log("Survey changed", args);
    var value = args.valuesHash;
    var valueStr = JSON.stringify(value, null, 2);
    setLocalContent(args);
    writeBack(valueStr, true);
  };

  const onPageChanged = (args) => {
    if (args.currentPageNo === 1) {
      setLocalContent(args);
    }
  };

  const surveyCompleted = (args) => {
    console.log("Survey completed", args);
    var value = args.valuesHash;
    var valueStr = JSON.stringify(value, null, 2);
    setLocalContent(args);
    writeBack(valueStr, true);
  };

  return (
    <div className={cn(classes.editorContainer, "dx-theme-border-color")}>
      <Survey.Survey
        id={widgetId}
        model={localContent || survey}
        showCompletedPage={true}
        onValueChanged={(e) => onValueChanged(e)}
        onCurrentPageChanged={(e) => onPageChanged(e)}
        onComplete={(e) => surveyCompleted(e)}
      />
    </div>
  );
}